export default "__VITE_ASSET__CH_MGWF7__"